module.exports = __webpack_public_path__ + "static/leaf@2x-5c3c3fe5365062e7548c3ee247a181ac.png";